export const getters = {

    getLocation (state) {
        return state.location
    }
}